var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,45A45,45,0,1,1,45,90,45,45,0,0,1,0,45Z",
    fill: "#0077b5",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.22,37.1l.06-.09V32.43H39c.11,3,0,32.26,0,32.26H49.28v-18A7.55,7.55,0,0,1,49.61,44a5.64,5.64,0,0,1,5.26-3.91c3.71,0,5.21,3,5.21,7.29V64.69H70.31V46.18c0-9.9-5.06-14.51-11.81-14.51A10,10,0,0,0,49.28,37v.09ZM28.24,28h0A5.45,5.45,0,0,0,34,22.44a5.43,5.43,0,0,0-5.74-5.56,5.46,5.46,0,0,0-5.79,5.56A5.41,5.41,0,0,0,28.15,28Zm5.12,36.68h0V32.43H23.12V64.69Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLinkedin);
export default __webpack_public_path__ + "static/media/share-linkedin.420dd4a3934d7ded364cf0109f3e7e6e.svg";
export { ForwardRef as ReactComponent };